// Mock data for SMT Services

export const companyInfo = {
  name: "SMT SERVICES",
  logo: "/logo-smt.png",
  phone: "06 25 68 48 49",
  email: "smt.services17t@gmail.com",
  location: "Chaillevette et environs (25 km)",
  serviceArea: [
    "Chaillevette", "Étaules", "Mornac-sur-Seudre", "Breuillet", "L'Éguille-sur-Seudre",
    "La Tremblade", "Arvert", "Les Mathes", "La Palmyre", "Saint-Augustin",
    "Saint-Palais-sur-Mer", "Vaux-sur-Mer", "Royan", "Médis", "Saujon",
    "Le Gua", "Saint-Sulpice-de-Royan", "Saint-Georges-de-Didonne", "Meschers-sur-Gironde",
    "Cozes", "Marennes", "Bourcefranc-le-Chapus", "Le Château-d'Oléron", "Dolus-d'Oléron"
  ],
  instagram: "smtservices17",
  facebook: "SMT Services Clean",
  facebookUrl: "https://www.facebook.com/share/18bB9rqaqu/?mibextid=wwXIfr",
  tiktok: "SMTSERVICES17",
  googleReviewsUrl: "https://maps.app.goo.gl/o4wChVQr51yJxdSg9?g_st=ic",
  googleLeaveReviewUrl: "https://g.page/r/Ceaf3gp_Oe-rEBE/review"
};

export const services = [
  {
    id: "vitres",
    name: "Nettoyage de Vitres",
    description: "Nettoyage professionnel de toutes vos vitres, fenêtres et baies vitrées pour une transparence parfaite.",
    icon: "Sparkles",
    category: "vitres"
  },
  {
    id: "veranda",
    name: "Nettoyage de Véranda",
    description: "Entretien complet de votre véranda : vitres, toiture et structure pour un espace lumineux.",
    icon: "Home",
    category: "vitres"
  },
  {
    id: "menage_pro",
    name: "Ménage Professionnels",
    description: "Nettoyage de vos locaux commerciaux, bureaux, boutiques et espaces professionnels. Service régulier ou ponctuel.",
    icon: "Building2",
    category: "menage"
  },
  {
    id: "menage_particulier",
    name: "Ménage Particuliers",
    description: "Entretien de votre maison ou appartement. Bénéficiez de 50% de déduction d'impôt sur les prestations à domicile.",
    icon: "HomeIcon",
    category: "menage",
    hasDeduction: true
  },
  {
    id: "fin_chantier",
    name: "Nettoyage Fin de Chantier",
    description: "Remise en état après travaux : élimination des poussières, résidus et traces de chantier.",
    icon: "HardHat",
    category: "special"
  },
  {
    id: "moquette_canape",
    name: "Nettoyage Moquette & Canapé",
    description: "Nettoyage en profondeur de tous types de moquettes, tapis et canapés. Résultat impeccable garanti.",
    icon: "Sofa",
    category: "special"
  }
];

export const options = [
  {
    id: "encadrements",
    name: "Nettoyage des encadrements",
    description: "Nettoyage des cadres de fenêtres et portes"
  },
  {
    id: "volets",
    name: "Nettoyage des volets",
    description: "Nettoyage intérieur et extérieur des volets"
  },
  {
    id: "terrasse",
    name: "Nettoyage de terrasse",
    description: "Nettoyage haute pression de votre terrasse"
  }
];

export const availability = {
  monday: { available: true, start: "13:30", end: "16:00", label: "Lundi" },
  tuesday: { available: true, start: "10:00", end: "12:00", label: "Mardi" },
  wednesday: { available: true, start: "12:30", end: "16:30", label: "Mercredi" },
  thursday: { available: true, start: "09:30", end: "11:30", label: "Jeudi" },
  friday: { available: true, start: "10:00", end: "15:30", label: "Vendredi" },
  saturday: { available: false, start: null, end: null, label: "Samedi" },
  sunday: { available: false, start: null, end: null, label: "Dimanche" }
};

// Opening hours of the company (display only, not the booking calendar)
export const openingHours = [
  { label: "Lundi", value: "07:30 - 17:30", open: true },
  { label: "Mardi", value: "07:30 - 17:30", open: true },
  { label: "Mercredi", value: "07:30 - 17:30", open: true },
  { label: "Jeudi", value: "07:30 - 17:30", open: true },
  { label: "Vendredi", value: "07:30 - 17:30", open: true },
  { label: "Samedi", value: "Fermé", open: false },
  { label: "Dimanche", value: "Fermé", open: false },
  { label: "Jours fériés", value: "Fermé", open: false }
];
const getEasterSunday = (year) => {
  const a = year % 19;
  const b = Math.floor(year / 100);
  const c = year % 100;
  const d = Math.floor(b / 4);
  const e = b % 4;
  const f = Math.floor((b + 8) / 25);
  const g = Math.floor((b - f + 1) / 3);
  const h = (19 * a + b - d - g + 15) % 30;
  const i = Math.floor(c / 4);
  const k = c % 4;
  const l = (32 + 2 * e + 2 * i - h - k) % 7;
  const m = Math.floor((a + 11 * h + 22 * l) / 451);
  const month = Math.floor((h + l - 7 * m + 114) / 31);
  const day = ((h + l - 7 * m + 114) % 31) + 1;
  return new Date(year, month - 1, day);
};

const addDays = (date, days) => {
  const d = new Date(date);
  d.setDate(d.getDate() + days);
  return d;
};

const ymd = (date) =>
  `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;

// French public holidays (jours fériés) for a given year.
export const getFrenchHolidays = (year) => {
  const easter = getEasterSunday(year);
  const dates = [
    new Date(year, 0, 1),    // Jour de l'An
    addDays(easter, 1),      // Lundi de Pâques
    new Date(year, 4, 1),    // Fête du Travail
    new Date(year, 4, 8),    // Victoire 1945
    addDays(easter, 39),     // Jeudi de l'Ascension
    addDays(easter, 50),     // Lundi de Pentecôte
    new Date(year, 6, 14),   // Fête nationale
    new Date(year, 7, 15),   // Assomption
    new Date(year, 10, 1),   // Toussaint
    new Date(year, 10, 11),  // Armistice
    new Date(year, 11, 25),  // Noël
  ];
  return new Set(dates.map(ymd));
};

// Pre-compute holidays for the current and next 2 years.
const _currentYear = new Date().getFullYear();
const _holidaySet = new Set([
  ...getFrenchHolidays(_currentYear),
  ...getFrenchHolidays(_currentYear + 1),
  ...getFrenchHolidays(_currentYear + 2),
]);

export const isFrenchHoliday = (date) => _holidaySet.has(ymd(date));

// Generate time slots based on day
export const generateTimeSlots = (day) => {
  const dayConfig = availability[day];
  if (!dayConfig || !dayConfig.available) return [];
  
  const slots = [];
  const [startHour, startMin] = dayConfig.start.split(':').map(Number);
  const [endHour, endMin] = dayConfig.end.split(':').map(Number);
  
  let currentHour = startHour;
  let currentMin = startMin;
  
  while (currentHour < endHour || (currentHour === endHour && currentMin < endMin)) {
    const timeString = `${String(currentHour).padStart(2, '0')}:${String(currentMin).padStart(2, '0')}`;
    slots.push(timeString);
    
    currentMin += 30;
    if (currentMin >= 60) {
      currentMin = 0;
      currentHour += 1;
    }
  }
  
  return slots;
};

// Mock bookings (will be replaced by backend)
export const mockBookings = [
  { date: "2025-08-05", time: "14:00" },
  { date: "2025-08-06", time: "10:00" }
];

// Google Reviews - Vrais avis de la page Google SMT Services (mis à jour)
export const googleReviews = [
  {
    id: 1,
    name: "Maryse Thevenieau",
    rating: 5,
    date: "Il y a 1 mois",
    text: "Étant dans l'incapacité de faire mes vitres depuis 6 mois, j'étais ravie de revoir à travers. Travail sérieux. Je suis entièrement satisfaite du travail. Je recommande ce professionnel les yeux fermés.",
    avatar: "MT",
    isLocalGuide: true
  },
  {
    id: 2,
    name: "Chloé",
    rating: 5,
    date: "Il y a 1 mois",
    text: "Si vous souhaitez une prestation bien faite, dans une bonne ambiance ! C'est ce monsieur qu'il vous faut ! Travail bien fait et minutieux, avec le sourire et très agréable. Merci encore ! À recommander les yeux fermés.",
    avatar: "C"
  },
  {
    id: 3,
    name: "Laetitia Descazeaux",
    rating: 5,
    date: "Il y a 1 mois",
    text: "À domicile. Service impeccable, je recommande vivement.",
    avatar: "LD"
  },
  {
    id: 4,
    name: "Lolita Portron",
    rating: 5,
    date: "Il y a 2 mois",
    text: "Très professionnel. Rien à dire. Travail très bien réalisé.",
    avatar: "LP"
  },
  {
    id: 5,
    name: "Ghislaine Mounier",
    rating: 5,
    date: "Il y a 4 mois",
    text: "Très satisfaite du travail de ce professionnel qui intervient sur mes baies vitrées qui sont d'accès difficiles et atypiques. J'apprécie son travail soigné et sa discrétion. Je recommande donc ce monsieur sans hésitation.",
    avatar: "GM"
  },
  {
    id: 6,
    name: "Corinne Haudebourg",
    rating: 5,
    date: "Il y a 6 mois",
    text: "Personne très agréable et très professionnelle. Je recommande vivement. Merci encore pour le travail effectué. À bientôt. Corinne.",
    avatar: "CH",
    isLocalGuide: true
  },
  {
    id: 7,
    name: "Jogi Verhaeghe",
    rating: 5,
    date: "Il y a 6 mois",
    text: "Très bien. Travail propre. Nous avons apprécié la ponctualité, l'efficacité et l'amabilité du laveur de vitres.",
    avatar: "JV"
  },
  {
    id: 8,
    name: "Isabelle de Logivière",
    rating: 5,
    date: "Il y a 6 mois",
    text: "Nous sommes ravis de la société SMT, excellent travail avec le souci du détail. Nous recommandons SMT services.",
    avatar: "IL"
  }
];

export const googleStats = {
  averageRating: 4.8,
  totalReviews: 28
};

// Réalisations / Avant-Après — photos fournies par le client
export const realisations = [
  {
    id: "terrasse",
    title: "Nettoyage de Terrasse",
    description: "Nettoyage haute pression d'une terrasse extérieure. Le carrelage retrouve son éclat d'origine, débarrassé de la mousse et des salissures.",
    image: "https://customer-assets.emergentagent.com/job_77acf5b0-bce4-4f1b-9869-3607f8c62307/artifacts/7bo9bcgk_DA8AB211-7425-45EB-AC74-96D9E3A368A0.png",
    tag: "Extérieur"
  },
  {
    id: "vitre-exterieure",
    title: "Vitre Extérieure",
    description: "Nettoyage d'une grande vitre couverte de calcaire et de poussière. Vue extérieure parfaitement dégagée après intervention.",
    image: "https://customer-assets.emergentagent.com/job_77acf5b0-bce4-4f1b-9869-3607f8c62307/artifacts/rjerom6m_A1E8925B-3E33-4186-9024-D030CEBC5D88.png",
    tag: "Vitres"
  },
  {
    id: "baie-vitree",
    title: "Baie Vitrée",
    description: "Nettoyage d'une baie vitrée donnant sur jardin et piscine. Transparence totale, sans traces ni résidus.",
    image: "https://customer-assets.emergentagent.com/job_77acf5b0-bce4-4f1b-9869-3607f8c62307/artifacts/4im21rvb_932F0604-C1DE-4C94-A89B-3268BADEEF61.png",
    tag: "Baies vitrées"
  },
  {
    id: "encadrement",
    title: "Encadrement de Fenêtre",
    description: "Élimination de la moisissure et des dépôts noirs sur l'encadrement. La fenêtre retrouve un aspect comme neuf.",
    image: "https://customer-assets.emergentagent.com/job_77acf5b0-bce4-4f1b-9869-3607f8c62307/artifacts/737lq00t_CF2098B8-7AE6-47A6-90D6-9A3003BF3709.png",
    tag: "Encadrements"
  }
];
